import { useState } from 'react';
import api from '../services/api';

function Login({ onLogin, onBack }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const session = await api.login(email, password);
      sessionStorage.setItem('lexsovereign_session', JSON.stringify(session));
      onLogin(session);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string') setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(e => e.msg || JSON.stringify(e)).join(' '));
      else setError('Error de autenticacion');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '14px 16px',
    background: 'rgba(237,224,196,0.05)',
    border: '1px solid rgba(200,150,62,0.25)',
    color: '#ede0c4',
    fontSize: '13px',
    fontFamily: "'JetBrains Mono', monospace",
    letterSpacing: '1px',
    outline: 'none',
    borderRadius: '2px',
    transition: 'border-color 0.3s'
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0c10',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'JetBrains Mono', monospace"
    }}>
      <link href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@200;300;400;500;600&display=swap" rel="stylesheet" />

      <div style={{
        width: '420px',
        padding: '50px 40px',
        background: 'rgba(20,22,28,0.95)',
        border: '1px solid rgba(200,150,62,0.15)',
        borderRadius: '4px'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            width: 50, height: 50,
            border: '1px solid rgba(200,150,62,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', fontSize: 20, color: '#C8963E'
          }}>⚖</div>
          <div style={{
            fontSize: '20px',
            fontWeight: 300,
            color: '#C8963E',
            letterSpacing: '6px',
            marginBottom: '8px'
          }}>LEXSOVEREIGN</div>
          <div style={{
            fontSize: '9px',
            color: 'rgba(237,224,196,0.35)',
            letterSpacing: '3px'
          }}>PLATAFORMA DE INTELIGENCIA LEGAL</div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} data-testid="login-form">
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '9px', color: 'rgba(237,224,196,0.45)', letterSpacing: '2px', marginBottom: '8px' }}>
              EMAIL
            </label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="usuario@empresa.com"
              required
              style={inputStyle}
              onFocus={e => e.target.style.borderColor = '#C8963E'}
              onBlur={e => e.target.style.borderColor = 'rgba(200,150,62,0.25)'}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '9px', color: 'rgba(237,224,196,0.45)', letterSpacing: '2px', marginBottom: '8px' }}>
              PASSWORD
            </label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={inputStyle}
              onFocus={e => e.target.style.borderColor = '#C8963E'}
              onBlur={e => e.target.style.borderColor = 'rgba(200,150,62,0.25)'}
            />
          </div>

          {error && (
            <div data-testid="login-error" style={{
              padding: '10px 14px',
              background: 'rgba(229,62,62,0.1)',
              border: '1px solid rgba(229,62,62,0.3)',
              color: '#E53E3E',
              fontSize: '11px',
              marginBottom: '16px',
              borderRadius: '2px'
            }}>
              {error}
            </div>
          )}

          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              background: loading ? 'rgba(200,150,62,0.5)' : '#C8963E',
              color: '#0a0c10',
              border: 'none',
              fontSize: '12px',
              fontWeight: 600,
              letterSpacing: '3px',
              cursor: loading ? 'wait' : 'pointer',
              fontFamily: "'JetBrains Mono', monospace",
              borderRadius: '2px',
              transition: 'all 0.3s'
            }}
          >
            {loading ? 'AUTENTICANDO...' : 'ACCEDER'}
          </button>
        </form>

        {/* Footer */}
        <div style={{ marginTop: '32px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '14px' }}>
          {onBack && (
            <button
              data-testid="login-back-btn"
              onClick={onBack}
              style={{
                background: 'transparent',
                border: '1px solid rgba(200,150,62,0.2)',
                color: 'rgba(237,224,196,0.45)',
                borderRadius: '2px',
                padding: '8px 24px',
                fontSize: '10px',
                fontFamily: "'JetBrains Mono', monospace",
                letterSpacing: '2px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              ← VOLVER A MIDAS
            </button>
          )}
          <div style={{
            color: 'rgba(237,224,196,0.2)',
            fontSize: '8px',
            letterSpacing: '2px'
          }}>
            CLASIFICADO — CONFIDENCIAL
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
